import type { ReactNode } from 'react';
import { STATUS_SYMBOL } from '@/lib/verdict';
import styles from './StatusRow.module.css';

export type StatusKind = 'safe' | 'alert' | 'neutral';

type Props = {
  icon?: ReactNode;
  label: ReactNode;
  detail?: ReactNode;
  status: StatusKind;
  statusLabel: string;
};

export default function StatusRow({
  icon,
  label,
  detail,
  status,
  statusLabel,
}: Props) {
  return (
    <div className={styles.row}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <div className={styles.body}>
        <div className={styles.label}>{label}</div>
        {detail && <div className={styles.detail}>{detail}</div>}
      </div>
      <span className={`${styles.status} ${styles[`status-${status}`]}`}>
        {statusLabel}
        <span className={styles.statusSymbol} aria-hidden="true">
          {STATUS_SYMBOL[status]}
        </span>
      </span>
    </div>
  );
}
